module.exports = __webpack_public_path__ + "img/logo.d1b015f5.png";